import React, { useState, useEffect } from 'react';
import config from '../../config/apiConfig';
import { usePlan } from '../context/PlanContext';
import WizardConfiguracion from './WizardConfiguracion';

// Iconos
const ClipboardIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="opacity-50"><path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" /><rect x="8" y="2" width="8" height="4" rx="1" ry="1" /></svg>);
const DollarIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="opacity-50"><line x1="12" y1="1" x2="12" y2="23" /><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" /></svg>);
const ClockIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="opacity-50"><circle cx="12" cy="12" r="10" /><polyline points="12 6 12 12 16 14" /></svg>);
const AlertIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="opacity-50"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>);
const ReceiptIcon = () => (<svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="opacity-50"><path d="M4 2h16v20l-3-2-2 2-2-2-2 2-2-2-2 2-3-2z"/><line x1="8" y1="7" x2="16" y2="7"/><line x1="8" y1="11" x2="16" y2="11"/></svg>);

const Home = ({ branchName }) => {
    const [metrics, setMetrics] = useState({ totalVentas: 0, activas: 0, pedidosHoy: 0, tiempoPromedio: 0 });
    const [business, setBusiness] = useState({ nombre: '', logo: '' });
    const [criticos, setCriticos] = useState({ count: 0, items: [] }); // <--- NUEVO ESTADO
    const [loading, setLoading] = useState(true);
    const { tienePOS, plan } = usePlan();
    // 🚩 Wizard de primeros pasos: modal flotante, disponible en plan POS y
    // RESTAURANTE (MenúQR tiene su propio wizard en InicioMenuQR). Se abre
    // por defecto y el usuario lo cierra con la X cuando quiere -- salvo que
    // ya haya quedado marcado como completo antes (ver WizardConfiguracion),
    // en cuyo caso no vuelve a aparecer solo.
    const [wizardAbierto, setWizardAbierto] = useState(() => localStorage.getItem('komity_wizard_completado') !== 'true');
    const mostrarWizard = plan === 'POS' || plan === 'RESTAURANTE';

    const fetchData = async () => {
        const token = localStorage.getItem("token");
        const headers = { 'token': token };

        try {
            // Cargar Métricas KDS
            const resM = await fetch(`${config.api_url}/api/kds/dashboard-resumen`, { headers });
            const dataM = await resM.json();
            if (dataM.status === 'success') {
                setMetrics({
                    totalVentas: dataM.data.total_ventas,
                    activas: dataM.data.cantidad_activas,
                    pedidosHoy: dataM.data.pedidos_hoy,
                    tiempoPromedio: dataM.data.tiempo_promedio_min
                });
            }

            // Cargar Stock Crítico <--- NUEVA LLAMADA
            const resC = await fetch(`${config.api_url}/api/inventario/criticos`, { headers });
            const dataC = await resC.json();
            if (dataC.status === 'success') {
                setCriticos({ count: dataC.count, items: dataC.items });
            }

            // Cargar Info Negocio
            const resB = await fetch(`${config.api_url}/api/negocios/detalle`, { headers });
            const dataB = await resB.json();
            if (resB.ok) setBusiness(dataB);

        } catch (error) {
            console.error("❌ Error cargando dashboard:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData();
        const interval = setInterval(fetchData, 60000);
        return () => clearInterval(interval);
    }, []);

    const stats = [
        { title: "Ventas Hoy", value: `$${(metrics.totalVentas || 0).toLocaleString('es-CL')}`, color: 'success', icon: DollarIcon, desc: 'Pagado hoy' },
        { title: "Pedidos Hoy", value: (metrics.pedidosHoy || 0).toString(), color: 'primary', icon: ReceiptIcon, desc: 'Total del día' },
        { title: "Pedidos en Cocina", value: (metrics.activas || 0).toString(), color: 'warning', icon: ClipboardIcon, desc: 'En preparación ahora' },
        { title: "Tiempo Promedio", value: `${metrics.tiempoPromedio || 0} min`, color: 'info', icon: ClockIcon, desc: 'Creación → entrega' },
        { title: "Stock Crítico", value: criticos.count.toString(), color: criticos.count > 0 ? 'danger' : 'secondary', icon: AlertIcon, desc: 'Productos por agotarse' },
    ];

    const logoUrl = business.logo ? `${config.api_url}/static/uploads/logos/${business.logo}` : null;

    return (
        <div className="min-vh-100 bg-light py-4">
            {mostrarWizard && wizardAbierto && (
                <WizardConfiguracion plan={plan} onClose={() => setWizardAbierto(false)} />
            )}
            <div className="container">
                {/* HEADER */}
                <div className="row mb-4 align-items-center">
                    <div className="col-12 col-md-8 d-flex align-items-center">
                        {logoUrl ? (
                            <img src={logoUrl} alt="Logo" className="rounded-circle shadow-sm border bg-white mr-3" style={{ width: '70px', height: '70px', objectFit: 'cover' }} />
                        ) : (
                            <div className="rounded-circle bg-dark text-white d-flex align-items-center justify-content-center mr-3 shadow-sm" style={{ width: '70px', height: '70px' }}>
                                <span className="h4 mb-0">{business.nombre ? business.nombre.charAt(0) : 'N'}</span>
                            </div>
                        )}
                        <div>
                            <h1 className="h2 font-weight-bold text-dark mb-0">{business.nombre || 'Mi Negocio'}</h1>
                            {localStorage.getItem('terminalNombre')
                                ? <p className="text-muted mb-0"><span className="badge badge-dark mr-2">Caja:</span> {localStorage.getItem('terminalNombre') || 'Sin nombre'}</p>
                                : <p className="text-muted mb-0"><span className="badge badge-dark mr-2">Sucursal:</span> {branchName || 'Principal'}</p>
                            }
                        </div>
                    </div>
                    {tienePOS && (
                        <div className="col-12 col-md-4 text-md-right mt-3 mt-md-0">
                            <button onClick={() => window.location.href = '/ventas/tpv/'} className="btn btn-dark btn-lg px-4 shadow-sm">Ir a TPV</button>
                        </div>
                    )}
                </div>

                {/* ALERTA VISUAL DE STOCK (SOLO SI HAY CRÍTICOS) */}
                {criticos.count > 0 && (
                    <div className="alert alert-danger shadow-sm border-0 mb-4 animate__animated animate__pulse animate__infinite" style={{ borderRadius: '15px' }}>
                        <div className="d-flex align-items-center">
                            <i className="fas fa-exclamation-triangle fa-2x mr-3"></i>
                            <div>
                                <h5 className="alert-heading font-weight-bold mb-1">¡Atención! Hay productos por agotarse</h5>
                                <p className="mb-0 small">
                                    {criticos.items.slice(0, 3).map(i => `${i.nombre} (${parseFloat(i.stock)})`).join(', ')}
                                    {criticos.count > 3 ? ` y ${criticos.count - 3} más...` : ''}
                                </p>
                            </div>
                            <button className="btn btn-outline-danger btn-sm ml-auto font-weight-bold" onClick={() => window.location.href='/admin/inventario/'}>Reponer ahora</button>
                        </div>
                    </div>
                )}

                {/* TARJETAS DE ESTADÍSTICAS */}
                <div className="card shadow-sm border-0 rounded-lg p-4">
                    <h4 className="mb-4 font-weight-bold">Estadísticas Clave</h4>
                    <div className="row row-cols-2 row-cols-md-5">
                        {loading ? (
                            <div className="col-12 text-center py-5"><div className="spinner-border text-primary"></div></div>
                        ) : (
                            stats.map((stat, index) => (
                                <div className="col mb-3" key={index}>
                                    <div className={`card bg-${stat.color} text-white shadow h-100 border-0`} style={{ borderRadius: '15px' }}>
                                        <div className="card-body">
                                            <div className="d-flex align-items-center justify-content-between">
                                                <div>
                                                    <h6 className="card-title text-uppercase opacity-75 small font-weight-bold">{stat.title}</h6>
                                                    <h2 className="card-text font-weight-bold mb-1">{stat.value}</h2>
                                                    <small className="opacity-75">{stat.desc}</small>
                                                </div>
                                                <stat.icon />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Home;